import { useState } from "react";
import { Input, Button, Table, Space, message } from "antd";

const Query = () => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState<any[]>([]);
    const [columns, setColumns] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const [showWidget, setShowWidget] = useState(true);

    const columnMap: Record<string, string> = {
        index: "編號",
        key: "關鍵字",
        description: "描述",
        event: "事件連結",
        level: "級別",
    };

    // === 查詢 ===
    const handleSearch = async () => {
        if (!query.trim()) {
            message.warning("請輸入關鍵字！");
            return;
        }

        setLoading(true);
        setHasSearched(true);

        try {
            const response = await fetch(`/api/query?key=${query}`);
            const rawData = await response.json();

            console.log("🚀 ~ file: Query.tsx ~ line 100 ~ handleSearch ~ rawData", rawData);

            if (typeof rawData !== "object" || rawData === null) {
                throw new Error("API 回傳的資料格式不正確");
            }

            const expandedData: any[] = [];
            let indexCounter = 1;

            Object.entries(rawData).forEach(([key, values]) => {
                if (Array.isArray(values)) {
                    values.forEach((value) => {
                        expandedData.push({ index: indexCounter++, key, ...value });
                    });
                }
            });

            setColumns(
                Object.keys(expandedData[0] || {}).map((key) => ({
                    title: columnMap[key] || key,
                    dataIndex: key,
                    key,
                    render:
                        key === "event"
                            ? (text: string) => (
                                <a href={text} target="_blank" rel="noopener noreferrer">
                                    查看
                                </a>
                            )
                            : undefined,
                }))
            );

            setResults(expandedData);
        } catch (error) {
            console.error("❌ 查詢失敗:", error);
            setResults(["error"]);
        } finally {
            setLoading(false);
        }
    };

    // === 清除 ===
    const handleClear = () => {
        setResults([]);
        setQuery("");
        setHasSearched(false);
    };

    // === 關閉浮動 Widget ===
    const handleCloseWidget = () => {
        setShowWidget(false);
    };

    return (
        <div style={{ padding: 20, textAlign: "center" }}>
            {/* 最上方聲明 / 警告 */}
            <div
                style={{
                    maxWidth: 960,
                    margin: "0 auto 18px auto",
                    padding: "10px 16px",
                    backgroundColor: "#fff5f5",
                    border: "1px solid #f2c7c7",
                    borderRadius: "6px",
                    textAlign: "center",
                    lineHeight: "1.7",
                }}
            >
                <span
                    style={{
                        color: "#b42318",
                        fontSize: "14px",
                        fontWeight: 600,
                    }}
                >
                    聲明：
                </span>
                <span
                    style={{
                        color: "#7a271a",
                        fontSize: "14px",
                    }}
                >
                    本工具與犬貓黑名單社團毫無關聯，資料由捍衛動物管理群自行蒐證、整理、建置資料庫，並整合網路上各式來源黑名單。
                </span>
            </div>
            {/* 原本的說明文案 */}
            <p
                style={{
                    color: "#444",
                    fontSize: "15px",
                    lineHeight: "1.6",
                    marginBottom: "15px",
                }}
            >
                此平台提供名單查詢，您可以輸入
                <strong style={{ color: "#007bff" }}> 姓名、通訊暱稱跟ID</strong> 等關鍵字，來檢查該人是否曾有不良紀錄，以確保動物的安全。
                <br />
                如需查詢多人可將關鍵字用頓號區隔，例如：
                <strong style={{ color: "#ff5733" }}> 姓名1、LineID2、暱稱3</strong>。
            </p>

            {/* 查詢與清除按鈕 - 已修正手機版布局 */}
            <div
                style={{
                    display: "flex",
                    flexDirection: window.innerWidth < 768 ? "column" : "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    marginBottom: "20px",
                }}
            >
                <Input
                    placeholder="請輸入"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    style={{
                        width: window.innerWidth < 768 ? "90%" : 600,
                        maxWidth: "600px",
                    }}
                />
                <Space>
                    <Button type="primary" onClick={handleSearch} loading={loading}>
                        查詢
                    </Button>
                    <Button type="default" onClick={handleClear}>
                        清除
                    </Button>
                </Space>
            </div>

            {/* 結果或其他狀態 */}
            {results[0] === "error" ? (
                <div style={{ paddingBottom: "100px", textAlign: "center" }}>
                    <p style={{ color: "#999", fontSize: "14px" }}>伺服器維護中，請稍後再試 ...</p>
                    <img
                        src="/404.jpg"
                        alt="Error 404"
                        style={{ width: "50%", maxWidth: "600px", display: "block", margin: "auto" }}
                    />
                </div>
            ) : !hasSearched ? (
                <div style={{ paddingBottom: "100px", textAlign: "center" }}>
                    <p style={{ color: "#999", fontSize: "14px", marginTop: "18px" }}>
                        邏輯貓將賜與你智慧與勇氣抉擇出對的人 ...
                    </p>
                    <img
                        src="/siamese.jpg"
                        alt="Siamese Cat"
                        style={{ width: "50%", maxWidth: "600px", display: "block", margin: "auto" }}
                    />
                </div>
            ) : (
                <Table
                    columns={
                        columns.length > 0
                            ? columns
                            : Object.keys(columnMap).map((key) => ({
                                title: columnMap[key] || key,
                                dataIndex: key,
                                key,
                            }))
                    }
                    dataSource={results}
                    style={{ marginTop: 20 }}
                    locale={{ emptyText: "沒有符合條件的資料" }}
                />
            )}

            {/* ============================= */}
            {/* 右下角浮動的社團宣傳 Widget   */}
            {/* ============================= */}
            {showWidget && (
                <div
                    style={{
                        position: "fixed",
                        bottom: 20,
                        right: 20,
                        width: 260,
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        padding: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                        zIndex: 9999,
                    }}
                >
                    {/* 關閉按鈕 */}
                    <Button
                        type="text"
                        onClick={handleCloseWidget}
                        style={{
                            float: "right",
                            fontWeight: "bold",
                            fontSize: "16px",
                            lineHeight: "1",
                            cursor: "pointer",
                        }}
                    >
                        ×
                    </Button>

                    {/* 內文 */}
                    <h4 style={{ margin: "0 0 8px 0", fontSize: "16px", color: "#d9534f" }}>
                        捍衛動物有臉書社團了！
                    </h4>
                    <p style={{ margin: 0, fontSize: "14px", color: "#444" }}>
                        提供黑名單教學、
                        <br />
                        匿名發表黑名單等功能
                    </p>

                    {/* 按鈕連結 */}
                    <Button
                        type="primary"
                        size="small"
                        style={{ marginTop: "8px" }}
                        onClick={() =>
                            window.open(
                                "https://www.facebook.com/groups/696508226172980",
                                "_blank"
                            )
                        }
                    >
                        立即加入
                    </Button>
                </div>
            )}
        </div>
    );
};

export default Query;